;(function () {
  'use strict'

  angular.module('contrast.common').constant('COMMON_DELIMITERS', {
    DOT: '.',
    UNDERSCORE: '_'
  })
})()
